import PersonInsurancePolicy from './PersonInsurancePolicy';

export default PersonInsurancePolicy;
